export enum SidenavContextTypes {
	PROJECT = 'PROJECT',
	RUN = 'RUN',
	CASE = 'CASE',
	EMPTY = 'EMPTY',
	USER = 'USER',
	WORKSPACE = 'WORKSPACE',
}
